import { apiSlice } from "./apiSlice";

export const assessmentGradeApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		// NEW: Get only actual grades for an assessment (clean data, no nulls)
		getGradesByAssessment: builder.query({
			query: (assessmentId) =>
				`/AssessmentGrade/assessment/${assessmentId}/grades-only`,
			providesTags: (result, error, assessmentId) => [
				{ type: "AssessmentGrade", id: assessmentId },
			],
		}),

		// LEGACY: Get grades by assessment ID with mixed data (includes nulls for ungraded students)
		getGradesByAssessmentLegacy: builder.query({
			query: (assessmentId) => `/AssessmentGrade/by-assessment/${assessmentId}`,
			providesTags: (result, error, assessmentId) => [
				{ type: "AssessmentGrade", id: `${assessmentId}-legacy` },
			],
		}),

		// Get all grades by assessment ID (including students without grades)
		getAllGradesByAssessment: builder.query({
			query: (assessmentId) =>
				`/AssessmentGrade/by-assessment/${assessmentId}/all`,
			providesTags: (result, error, assessmentId) => [
				{ type: "AssessmentGrade", id: `${assessmentId}-all` },
			],
		}),

		// Get grades by department
		getGradesByDepartment: builder.query({
			query: (departmentId) =>
				`/AssessmentGrade/grades-by-department-id/${departmentId}`,
			providesTags: (result, error, departmentId) => [
				{ type: "AssessmentGrade", id: `dept-${departmentId}` },
			],
		}),

		// Get grades by student
		getGradesByStudent: builder.query({
			query: (studentId) => `/AssessmentGrade/student/${studentId}/grades`,
			providesTags: (result, error, studentId) => [
				{ type: "AssessmentGrade", id: `student-${studentId}` },
			],
		}),

		// Create grade
		createAssessmentGrade: builder.mutation({
			query: (gradeData) => ({
				url: "/AssessmentGrade",
				method: "POST",
				body: gradeData,
			}),
			invalidatesTags: (result, error, gradeData) => [
				// Invalidate AssessmentGrade cache
				{ type: "AssessmentGrade", id: gradeData.subjectAssessmentId },
				{ type: "AssessmentGrade", id: `${gradeData.subjectAssessmentId}-all` },
				{
					type: "AssessmentGrade",
					id: `${gradeData.subjectAssessmentId}-legacy`,
				},
				{ type: "AssessmentGrade", id: `student-${gradeData.studentId}` },
				// Invalidate LazyGrades cache - THIS IS THE KEY FIX
				{ type: "LazyGrades", id: `student-${gradeData.studentId}` },
			],
		}),

		// Update grade
		updateAssessmentGrade: builder.mutation({
			query: ({ id, ...gradeData }) => ({
				url: `/AssessmentGrade/${id}`,
				method: "PUT",
				body: { id, ...gradeData },
			}),
			invalidatesTags: (result, error, { subjectAssessmentId, studentId }) => [
				// Invalidate AssessmentGrade cache
				{ type: "AssessmentGrade", id: subjectAssessmentId },
				{ type: "AssessmentGrade", id: `${subjectAssessmentId}-all` },
				{ type: "AssessmentGrade", id: `${subjectAssessmentId}-legacy` },
				{ type: "AssessmentGrade", id: `student-${studentId}` },
				// Invalidate LazyGrades cache - THIS IS THE KEY FIX
				{ type: "LazyGrades", id: `student-${studentId}` },
			],
		}),

		// Delete grade
		deleteAssessmentGrade: builder.mutation({
			query: (id) => ({
				url: `/AssessmentGrade/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: [
				{ type: "AssessmentGrade", id: "LIST" },
				{ type: "LazyGrades", id: "LIST" },
			],
		}),
	}),
});

export const {
	useGetGradesByAssessmentQuery,
	useGetGradesByAssessmentLegacyQuery,
	useGetAllGradesByAssessmentQuery,
	useGetGradesByDepartmentQuery,
	useGetGradesByStudentQuery,
	useCreateAssessmentGradeMutation,
	useUpdateAssessmentGradeMutation,
	useDeleteAssessmentGradeMutation,
} = assessmentGradeApiSlice;
